import useAgentData from '~/client/hooks/useAgentData';
import useCurrentUser from '~/client/hooks/user/useCurrentUser';
import useSite from '~/client/hooks/useSite';
import type { currencyConversion } from '~/schema/public';
import { useFavouritesSliderQuery } from './FavouritesSliderQuery.generated';

const useFavouritesSlider = () => {
  const { site } = useSite();
  const { deviceType: type } = useAgentData();
  const { walletCurrency } = useCurrentUser();
  const currency = (walletCurrency as currencyConversion) || 'BTC';
  const { data, loading } = useFavouritesSliderQuery({
    variables: { filter: { site, type }, currency },
  });
  const myFavourites = data?.casino?.myFavourites?.edges;
  return { myFavourites, loading };
};

export default useFavouritesSlider;
